const { getElement, getElements, formatMoney } = window.BAO.Utils

export class ProductVariantSwitch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.onOptionChange()
  }

  setupListeners () {
    this.onOptionChange = this.onOptionChange.bind(this)

    this.options.forEach((input) => {
      this.listeners.add(input, 'change', this.onOptionChange)
    })
  }

  onOptionChange () {
    if (!this.els.select.element) return

    const selectedValues = this.selectedOptions.map((option) => option.value)

    const matchingOption = getElements('option', {
      context: this.els.select.element,
    }).find((option) => {
      const option1 = option.dataset['option-1']
      const option2 = option.dataset['option-2']
      const option3 = option.dataset['option-3']
      return (
        (!option1 || selectedValues.includes(option1)) &&
        (!option2 || selectedValues.includes(option2)) &&
        (!option3 || selectedValues.includes(option3))
      )
    })

    if (!matchingOption) return

    const variantId = matchingOption.value
    const available = matchingOption.dataset.disabled !== 'true'

    this.els.select.element.value = variantId

    this.setAvailability(variantId, available)
    this.setVariantStock(variantId)
    this.updateWishlist(variantId)
    this.setPrice(matchingOption)
  }

  setAvailability (variantId, available) {
    const submit = getElement('[data-product-add-to-cart]', { context: this })
    const quickAdds = getElements('[data-quick-add-trigger]', {
      context: this,
    })

    if (submit) {
      submit.setAttribute('aria-hidden', !available)
    }

    if (quickAdds.length) {
      quickAdds.forEach((quickAdd) => {
        quickAdd.dataset.variant = variantId
        quickAdd.setAttribute('aria-hidden', available)
      })
    }
  }

  setVariantStock () {
    const currentColour = getElement('[name="options[Color]"]:checked', {
      context: this.el,
    })

    if (!currentColour) return

    const selectedColour = currentColour.value

    const sizes = getElements('[name="options[Size]"]', { context: this })

    sizes.forEach((size) => {
      const variant = getElements('option', {
        context: this.els.select.element,
      }).find((option) => {
        const optionValues = [
          option.dataset['option-1'],
          option.dataset['option-2'],
          option.dataset['option-3'],
        ]
        return (
          optionValues.includes(selectedColour) &&
          optionValues.includes(size.value)
        )
      })

      if (!size || !variant || !variant.dataset) return

      size.setAttribute('data-available', variant.dataset.disabled !== 'true')
    })

    const colours = getElements('[name="options[Color]"]', { context: this })

    colours.forEach((colour) => {
      const variant = getElements('option', {
        context: this.els.select.element,
      }).find((option) => {
        const optionValues = [
          option.dataset['option-1'],
          option.dataset['option-2'],
          option.dataset['option-3'],
        ]
        return optionValues.includes(colour.value)
      })

      if (!colour || !variant || !variant.dataset) return

      colour.setAttribute(
        'data-available',
        variant.dataset.disabled !== 'true',
      )
    })
  }

  updateWishlist (variantId) {
    const wishlistButton = getElement('.iWishAddColl', { context: this })

    if (!wishlistButton && !window.iWish && !window.iWishData) return

    wishlistButton.dataset.variant = variantId

    window.iWish.isInWishlist(wishlistButton.dataset.variant)
      ? wishlistButton.classList.add('iwishAdded')
      : wishlistButton.classList.remove('iwishAdded')

    wishlistButton.innerHTML = window.iWish.isInWishlist(
      wishlistButton.dataset.variant,
    )
      ? window.iWishData.iwish_added_txt
      : window.iWishData.iwish_add_txt
  }

  setPrice (variant) {
    const price = parseFloat(variant.dataset.price)
    const comparePrice = parseFloat(variant.dataset.comparePrice)

    const card = this.closest('.prd-BeautyCardLarge')

    const priceElement = getElement('[data-product-price]', { context: card })
    priceElement.innerHTML = formatMoney(price, window.theme.moneyFormat)

    const priceCompareElement = getElement('[data-product-price-compare]', {
      context: card,
    })

    if (!priceCompareElement) return
    priceCompareElement.innerHTML = formatMoney(
      comparePrice,
      window.theme.moneyFormat,
    )
    priceCompareElement.hidden = !comparePrice || comparePrice === price
  }

  get options () {
    return getElements('[data-product-option]', { context: this })
  }

  get selectedOptions () {
    return getElements('[data-product-option]:checked', { context: this })
  }
}

if (!customElements.get('product-variant-switch')) {
  customElements.define('product-variant-switch', ProductVariantSwitch)
}
